import React from "react";
import { useSelector } from "react-redux";

const UserStatistics = (  ) => {
   var { branches }  =  useSelector((state) => state.utilities);
  console.log(branches);
  var  activeBranches  =  branches !== null ? branches?.filter(branch=>{ return branch.branchStatus === '1'}).length : 0
  var  inActive  =  branches !== null ? branches?.filter(branch=>{ return branch.branchStatus === '2'}).length : 0
  var  pending  =  branches !== null ? branches?.filter(branch=>{ return branch.branchStatus === '3'}).length : 0
  var  suspended  =  branches !== null ? branches?.filter(branch=>{ return branch.branchStatus === '4'}).length : 0

   return (
       
    <div class="row g-4 mb-4">
    <div class="col-sm-6 col-xl-3">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-start justify-content-between">
            <div class="content-left">
              <span>Acive Branches</span>
              <div class="d-flex align-items-end mt-2">
                <h4 class="mb-0 me-2">{activeBranches}</h4>
               </div>
             </div>
            <span class="badge bg-label-success rounded p-2">
              <i class="bx bx-git-branch bx-sm"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
 
    <div class="col-sm-6 col-xl-3">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-start justify-content-between">
            <div class="content-left">
              <span>InActive Branhes</span>
              <div class="d-flex align-items-end mt-2">
                <h4 class="mb-0 me-2">{inActive}</h4>
               </div>
             </div>
            <span class="badge bg-label-secondary rounded p-2">
              <i class="bx bx-git-branch bx-sm"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-xl-3">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-start justify-content-between">
            <div class="content-left">
              <span>Pending Branches</span>
              <div class="d-flex align-items-end mt-2">
                <h4 class="mb-0 me-2">{pending}</h4>
               </div>
             </div>
            <span class="badge bg-label-warning rounded p-2">
              <i class="bx bx-git-branch bx-sm"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-xl-3">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-start justify-content-between">
            <div class="content-left">
              <span>Suspended Branches</span>
              <div class="d-flex align-items-end mt-2">
                <h4 class="mb-0 me-2">{suspended}</h4>
               </div>
             </div>
            <span class="badge bg-label-danger rounded p-2">
              <i class="bx bx-git-branch bx-sm"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
   );
};

export default UserStatistics;
